import { Modal, Button, notification, Table } from "antd";
import customerService from "../../services/CustomerService";
import { useEffect, useRef, useState } from "react";
import Lodder from "../../components/Lodder";
import "react-image-crop/dist/ReactCrop.css";
import { useSelector, useDispatch } from "react-redux";
import { setUser } from "../../states/user/userSlice";
import ReactCrop, {
  centerCrop,
  convertToPixelCrop,
  makeAspectCrop,
} from "react-image-crop";
import { CSVLink } from "react-csv";
import {
  LockOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
const ASPECT_RATIO = 1;
const MIN_DIMENSION = 200;
const Profile = () => {
  // #region initilization
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const userImage = null;
  const [crop, setCrop] = useState();
  const imgRef = useRef(null);
  const [imageDataUrl, setImageDataUrl] = useState(user.image);
  const previewCanvasRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [userId, setUserId] = useState(0);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [show, setShow] = useState(false);
  const [showImageModel, setShowImageModel] = useState(false);
  const [customerLegalTools, setCustomerLegalTools] = useState([]);
  const [imageSrc, setImageSrc] = useState("");
  const [imageError, setImageError] = useState("");
  const [firstNameValidation, setFirstNameValidation] = useState({
    isValid: true,
    message: "",
  });
  const [lastNameValidation, setLastNameValidation] = useState({
    isValid: true,
    message: "",
  });
  // #endregion

  // #region Helper Functions
  const ValidateFirstName = (value) => {
    if (!value.trim()) {
      setFirstNameValidation({
        isValid: false,
        message: "First name is required",
      });
      return false;
    } else if (value.length > 50) {
      setFirstNameValidation({
        isValid: false,
        message: "First name not more than 50 character",
      });
      return false;
    } else {
      setFirstNameValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const ValidateLastName = (value) => {
    if (!value.trim()) {
      setLastNameValidation({
        isValid: false,
        message: "Last name is required",
      });
      return false;
    } else if (value.length > 50) {
      setLastNameValidation({
        isValid: false,
        message: "Last name not more than 50 character",
      });
      return false;
    } else {
      setLastNameValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };
  const handleEditButton = () => {
    setVisible(true);
    setFirstName(user.customerFirstName);
    setLastName(user.customerLastName);
    setEmail(user.email);
    setUserId(user.customerId);
    setImageDataUrl(user.image);
  };
  const handleUpdateModelCancelButton = () => {
    setVisible(false);
    setFirstName(user.customerFirstName);
    setLastName(user.customerLastName);
    setEmail(user.email);
    setUserId(user.customerId);
    setImageDataUrl(userImage);
    setShowImageModel(false);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    setImageSrc("");
  };
  const handleUpdate = async () => {
    ValidateFirstName(firstName);
    ValidateLastName(lastName);
    if (ValidateFirstName(firstName) && ValidateLastName(lastName)) {
      setVisible(false);
      setShow(true);
      const userData = {
        customerFirstName: firstName,
        customerLastName: lastName,
        email: email,
        id: userId,
        image: imageDataUrl.split(",")[1],
      };

      customerService
        .UpdateCustomer(userData)
        .then((response) => {
          if (response.status) {
            setShow(false);
            notification.success({
              message: "Update successfully!",
            });
            dispatch(setUser(userData));
          }
        })
        .catch((error) => {
          setShow(false);
          notification.error({
            message: "An error occoured!",
          });
        });
    }
  };
  // #endregion

  // #region Use Effect
  useEffect(() => {
    setShow(true);
    document.title = "Profile";
    // customerService
    //   .GetCustomerLegalToolsById()
    //   .then((response) => {
    //     if (response.status) {
    //       setCustomerLegalTools(response.resultData);
    //     }
    //   })
    //   .finally(() => {
        setShow(false);
    //   });
  }, []);
  // #endregion

  // #region Image Crop
  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      // Read the content of the file using FileReader
      const reader = new FileReader();
      reader.onloadend = () => {
        const imageElement = new Image();
        const imageUrl = reader.result?.toString() || "";
        imageElement.src = imageUrl;
        imageElement.addEventListener("load", (e) => {
          if (imageError) {
            setImageError("");
          }
          const { naturalWidth, naturalHeight } = e.currentTarget;
          if (naturalHeight < MIN_DIMENSION || naturalWidth < MIN_DIMENSION) {
            setImageError("Image must be at least 200 X 200 pixels");
            setImageSrc("");
            return;
          }
        });
        setImageSrc(imageUrl);
      };
      reader.readAsDataURL(file);
    }
  };
  const onImageLoad = (e) => {
    const { width, height } = e.currentTarget;
    const cropWidthInPercent = (MIN_DIMENSION / width) * 100;
    const crop = makeAspectCrop(
      {
        unit: "%",
        width: cropWidthInPercent,
      },
      ASPECT_RATIO,
      width,
      height
    );
    const centeredCrop = centerCrop(crop, width, height);
    setCrop(centeredCrop);
  };
  const setCanvasPreview = (image, canvas, crop) => {
    const ctx = canvas.getContext("2d");
    if (!ctx) {
      throw new Error("No 2d context");
    }
    const pixelRatio = window.devicePixelRatio;
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = Math.floor(crop.width * scaleX * pixelRatio);
    canvas.height = Math.floor(crop.height * scaleY * pixelRatio);
    ctx.scale(pixelRatio, pixelRatio);
    ctx.imageSmoothingQuality = "high";
    ctx.save();
    const cropX = crop.x * scaleX;
    const cropY = crop.y * scaleY;
    ctx.translate(-cropX, -cropY);
    ctx.drawImage(
      image,
      0,
      0,
      image.naturalWidth,
      image.naturalHeight,
      0,
      0,
      image.naturalWidth,
      image.naturalHeight
    );
    ctx.restore();
  };
  //#endregion

  // #region table
  const columns = [
    {
      title: "CREATED",
      dataIndex: "createdDate",
      key: "createdDate",
      sorter: (a, b) => new Date(a.createdDate) - new Date(b.createdDate),
      render: (createdDate) => {
        return (
          <>
            {new Date(createdDate).toLocaleDateString("en-US", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}
          </>
        );
      },
    },
    {
      title: "LEGAL TOOL",
      dataIndex: "serviceName",
      key: "serviceName",
      sorter: (a, b) => a.serviceName.localeCompare(b.serviceName),
    },
    {
      title: "BUSINESS NAME",
      dataIndex: "businessName",
      key: "businessName",
      sorter: (a, b) => a.businessName.localeCompare(b.businessName),
    },
    {
      title: "STATUS",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => a.status.localeCompare(b.status),
      render: (status) => {
        return (
          <>
            {status === "In progress" && (
              <span className="in-progress">{status}</span>
            )}
            {status === "Completed" && (
              <span className="complete">{status}</span>
            )}
            {status === "Submitted" && (
              <span className="submitted">{status}</span>
            )}
          </>
        );
      },
    },
    {
      title: "Amount",
      dataIndex: "price",
      key: "price",
      sorter: (a, b) => a.price - b.price,
      render: (text, record) => {
        const price = record.price;
        const formattedAmount = `$${price}.00`;
        return formattedAmount;
      },
    },
  ];
  //#endregion
  // #region Make CSV File
  function getCurrentDate() {
    const currentDate = new Date();
    return currentDate.toLocaleDateString("en-US");
  }

  const currentDate = getCurrentDate();
  const filename = `My Legal Tools List - ${currentDate}.csv`;
  const exportColumns = [
    { label: "Created", key: "created" },
    { label: "Legal Tool", key: "legalTool" },
    { label: "Business Name", key: "businessName" },
    { label: "Status", key: "status" },
    { label: "Amount", key: "amount" },
  ];
  const filteredCSVData = customerLegalTools.map((customerLegalTool) => ({
    legalTool: customerLegalTool.serviceName,
    businessName: customerLegalTool.businessName,
    status: customerLegalTool.status,
    created: new Date(customerLegalTool.createdDate).toLocaleDateString(
      "en-US",
      {
        day: "numeric",
        month: "long",
        year: "numeric",
      }
    ),
    amount: `$${customerLegalTool.price}.00`,
  }));
  // #endregion

  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [newPasswordValidation, setNewPasswordValidation] = useState({
    isValid: false,
    message: "",
  });

  const [oldPasswordValidation, setOldPasswordValidation] = useState({
    isValid: false,
    message: "",
  });

  const [confirmPasswordValidation, setConfirmPasswordValidation] = useState({
    isValid: true,
    message: "",
  });

  const ValidateOldPassword = (value) => {
    if (!value.trim()) {
      setOldPasswordValidation({
        isValid: false,
        message: "Old password is required",
      });
    } else {
      setOldPasswordValidation({
        isValid: true,
        message: "",
      });
    }
  };

  const ValidateNewPassword = (value) => {
    if (!value.trim()) {
      setNewPasswordValidation({
        isValid: false,
        message: "New password is required",
      });
    } else if (value.length < 6) {
      setNewPasswordValidation({
        isValid: false,
        message: "New password must be at least 6 characters",
      });
    } else {
      setNewPasswordValidation({
        isValid: true,
        message: "",
      });
    }
  };

  const ValidateConfirmPassword = (value) => {
    if (!value.trim()) {
      setConfirmPasswordValidation({
        isValid: false,
        message: "Confirm password is required",
      });
    } else if (value !== newPassword) {
      setConfirmPasswordValidation({
        isValid: false,
        message: "New password and confirm password must be same",
      });
    } else {
      setConfirmPasswordValidation({
        isValid: true,
        message: "",
      });
    }
  };

  const handleOldPasswordChange = (event) => {
    setOldPassword(event.target.value);
    ValidateOldPassword(event.target.value);
  };
  const handleNewPasswordChange = (event) => {
    setNewPassword(event.target.value);
    ValidateNewPassword(event.target.value);
  };
  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
    ValidateConfirmPassword(event.target.value);
  };

  const handleFormSubmit = () => {
    setShow(true);
    ValidateOldPassword(oldPassword);
    ValidateNewPassword(newPassword);
    ValidateConfirmPassword(confirmPassword);
    if (
      newPasswordValidation.isValid &&
      oldPasswordValidation.isValid &&
      confirmPasswordValidation.isValid
    ) {
      if (oldPassword === newPassword) {
        notification.error({
          message: "Old password and new password must be different",
        });
        setShow(false);
      } else {
        var customerCredentials = {
          oldPassword: oldPassword,
          NewPassword: newPassword,
        };
        customerService
          .changePassword(customerCredentials)
          .then((response) => {
            if (response.status) {
              notification.success({
                message: "Password changed successfully!",
              });
              setShow(false);
            }
          })
          .catch((error) => {
            notification.error({
              message: "Incorrect old password",
            });
            setShow(false);
          });
      }
    } else {
      setShow(false);
    }
  };

  return (
    <>
      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <div className="content-header">
          <div className="container-fluid mt-5 pt-3">
            {/* <div className="row mx-lg-3 mx-0 my-3">
              <div className="col-lg-12">
                <div className="card border-0 shadow w-100 card-span mb-4">
                  <div className="card-header property-header py-3">
                    <div className="d-flex justify-content-between">
                      <h5 className="mb-0 property-heading-card">MY PROFILE</h5>
                      <i
                        className="fa-regular fa-pen-to-square edit-icon"
                        onClick={handleEditButton}
                      ></i>
                    </div>
                  </div>
                  <div className="user-profile py-3 px-lg-4 px-2">
                    <div className="bio-picture d-flex justify-content-left">
                      <img
                        src={user.image}
                        alt="profile-img"
                        className="img-fluid circle-user"
                      ></img>
                    </div>
                    <div className="bio">
                      <p>
                        <span>First Name: </span> {user.customerFirstName}
                      </p>
                    </div>
                    <div className="bio">
                      <p>
                        <span>Last Name: </span> {user.customerLastName}
                      </p>
                    </div>
                    <div className="bio">
                      <p>
                        <span>Email: </span> {user.email}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="row mx-lg-3 mx-0 my-3">
              <div className="col-lg-6 mb-3">
                <div className="card border-0 shadow w-100 card-span mb-4 h-100 ">
                  <div className="card-header property-header py-3">
                    <div className="d-flex justify-content-between">
                      <h5 className="mb-0 property-heading-card">MY PROFILE</h5>
                      <i
                        className="fa-regular fa-pen-to-square edit-icon"
                        onClick={handleEditButton}
                      ></i>
                    </div>
                  </div>
                  <div className="user-profile ms-3 mt-5 d-lg-flex align-items-center">
                    <div className="imgbio ms-0">
                      <img
                        src={user.image}
                        alt="profile-img"
                        className="img-fluid circle-user"
                      ></img>
                    </div>

                    <div className="userbio">
                      <div className="row">
                        <div className="w-26">
                          <span className="profile-text">First Name: </span>
                        </div>
                        <div className="w-74">
                          <p>{user.customerFirstName}</p>
                        </div>
                        <div className="w-26">
                          <span className="profile-text">Last Name: </span>
                        </div>
                        <div className="w-74">
                          <p>{user.customerLastName}</p>
                        </div>
                        <div className="w-26">
                          <span className="profile-text">Email: </span>
                        </div>
                        <div className="w-74">
                          <p>{user.email}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 mb-3">
                <div className="card border-0 shadow w-100 card-span mb-4 h-100">
                  <div className="card-header property-header py-3">
                    <div className="d-flex justify-content-between login-form">
                      <h5 className="mb-0 property-heading-card">
                        CHANGE PASSWORD
                      </h5>
                      {/* <Link
                        className="forgot-link"
                        onClick={handleFormSubmit}
                      >
                        CHANGE PASSWORD
                      </Link> */}
                    </div>
                  </div>
                  <div className="user-profile py-3 px-lg-4 px-2">
                    <form>
                      <input type="hidden" />
                      <div className="row">
                        <div className="mb-3 col-lg-12">
                          <label className="form-label" htmlFor="password">
                            Old Password<span style={{ color: 'red' }}>*</span>
                          </label>
                          <div style={{ position: "relative" }}>
                            <input
                              className="form-control"
                              type={showPassword ? "text" : "password"}
                              value={oldPassword}
                              onChange={handleOldPasswordChange}
                              style={{ padding: "0.375rem 2.75rem" }}
                            />
                            {showPassword ? (
                              <EyeOutlined
                                onClick={() => {
                                  setShowPassword(!showPassword);
                                }}
                                style={{
                                  position: "absolute",
                                  top: "11px",
                                  right: "11px",
                                }}
                              />
                            ) : (
                              <EyeInvisibleOutlined
                                onClick={() => {
                                  setShowPassword(!showPassword);
                                }}
                                style={{
                                  position: "absolute",
                                  top: "11px",
                                  right: "11px",
                                }}
                              />
                            )}
                            <LockOutlined
                              class="fa-solid fa-lock"
                              style={{
                                position: "absolute",
                                top: "11px",
                                left: "17px",
                              }}
                            ></LockOutlined>
                          </div>
                          {!oldPasswordValidation.isValid && (
                            <span style={{ color: "red" }}>
                              {oldPasswordValidation.message}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="mb-3 col-lg-6">
                          <label className="form-label" htmlFor="password">
                            New Password<span style={{ color: 'red' }}>*</span>
                          </label>
                          <div style={{ position: "relative" }}>
                            <input
                              className="form-control"
                              type={showNewPassword ? "text" : "password"}
                              value={newPassword}
                              onChange={handleNewPasswordChange}
                              style={{ padding: "0.375rem 2.75rem" }}
                            />
                            {showNewPassword ? (
                              <EyeOutlined
                                onClick={() => {
                                  setShowNewPassword(!showNewPassword);
                                }}
                                style={{
                                  position: "absolute",
                                  top: "11px",
                                  right: "11px",
                                }}
                              />
                            ) : (
                              <EyeInvisibleOutlined
                                onClick={() => {
                                  setShowNewPassword(!showNewPassword);
                                }}
                                style={{
                                  position: "absolute",
                                  top: "11px",
                                  right: "11px",
                                }}
                              />
                            )}
                            <LockOutlined
                              class="fa-solid fa-lock"
                              style={{
                                position: "absolute",
                                top: "11px",
                                left: "17px",
                              }}
                            ></LockOutlined>
                          </div>
                          {!newPasswordValidation.isValid && (
                            <span style={{ color: "red" }}>
                              {newPasswordValidation.message}
                            </span>
                          )}
                        </div>
                        <div className="mb-3 col-lg-6">
                          <label className="form-label" htmlFor="password">
                            Confirm Password<span style={{ color: 'red' }}>*</span>
                          </label>
                          <div style={{ position: "relative" }}>
                            <input
                              className="form-control"
                              type={showConfirmPassword ? "text" : "password"}
                              value={confirmPassword}
                              onChange={handleConfirmPasswordChange}
                              style={{ padding: "0.375rem 2.75rem" }}
                            />
                            {showConfirmPassword ? (
                              <EyeOutlined
                                onClick={() => {
                                  setShowConfirmPassword(!showConfirmPassword);
                                }}
                                style={{
                                  position: "absolute",
                                  top: "11px",
                                  right: "11px",
                                }}
                              />
                            ) : (
                              <EyeInvisibleOutlined
                                onClick={() => {
                                  setShowConfirmPassword(!showConfirmPassword);
                                }}
                                style={{
                                  position: "absolute",
                                  top: "11px",
                                  right: "11px",
                                }}
                              />
                            )}
                            <LockOutlined
                              class="fa-solid fa-lock"
                              style={{
                                position: "absolute",
                                top: "11px",
                                left: "17px",
                              }}
                            ></LockOutlined>
                          </div>
                          {!confirmPasswordValidation.isValid && (
                            <span style={{ color: "red" }}>
                              {confirmPasswordValidation.message}
                            </span>
                          )}
                        </div>
                        <div className="d-flex justify-content-end">
                          <button
                            type="button"
                            className="submit-button mt-3"
                            onClick={handleFormSubmit}
                          >
                            CHANGE PASSWORD
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="row mx-lg-3 mx-0 my-3">
              <div className="col-lg-12">
                <div className="card border-0 shadow card-span w-100">
                  <div className="card-header property-header py-3">
                    <div className="d-flex justify-content-between align-items-center search-input">
                      <h5 className="mb-0 property-heading-card">
                        MY LEGAL TOOLS
                      </h5>
                      <CSVLink
                        filename={filename}
                        data={filteredCSVData}
                        headers={exportColumns}
                        className="btn export submit-button ms-3"
                      >
                        EXPORT
                      </CSVLink>
                    </div>
                  </div>
                  <div className="p-4 mt-2 table-responsive">
                    <Table
                      dataSource={customerLegalTools}
                      columns={columns}
                      pagination={{
                        showSizeChanger: true,
                        pageSizeOptions: ["5", "10", "20", "50", "100"],
                        defaultPageSize: 10,
                        total: customerLegalTools.length,
                        showTotal: (total, range) =>
                          `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                        itemRender: (current, type, originalElement) => {
                          if (type === "prev") {
                            return <Button>Previous</Button>;
                          }
                          if (type === "next") {
                            return <Button>Next</Button>;
                          }
                          return originalElement;
                        },
                      }}
                    />
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      {/* <------Update Profile Model-------> */}
      <Modal
        className="custom-ant-modal"
        title="Update Profile"
        visible={visible}
        onCancel={handleUpdateModelCancelButton}
        footer={[
          <Button
            className="submit-button text-white"
            key="submit"
            type="primary"
            onClick={handleUpdate}
          >
            UPDATE
          </Button>,
          <Button
            className="btn-submit-secondary"
            key="back"
            onClick={() => {
              setFirstNameValidation({
                isValid: true,
                message: "",
              });
              setLastNameValidation({
                isValid: true,
                message: "",
              });
              handleUpdateModelCancelButton();
            }}
          >
            CANCEL
          </Button>,
        ]}
      >
        <div className="row mx-0 mx-lg-3">
          <div className="col-lg-12">
            <div className="text-center position-relative">
              <img
                src={imageDataUrl === null ? user.image : imageDataUrl}
                /* src="/base4.jpg" */
                alt="profile-img"
                className="img-fluid circle-user"
              ></img>
              <i
                className="fa-solid fa-camera-retro icon-camera"
                onClick={() => {
                  setShowImageModel(true);
                }}
              ></i>
            </div>

            <form className="row mt-4">
              <div className="col-md-6 mb-2">
                <label className="form-label">First Name</label>
                <span style={{ color: "red" }}>*</span>
                <input
                  type="text"
                  className="form-control"
                  value={firstName}
                  onChange={(event) => {
                    setFirstName(event.target.value);
                    ValidateFirstName(event.target.value);
                  }}
                />
                {!firstNameValidation.isValid && (
                  <span style={{ color: "red" }}>
                    {firstNameValidation.message}
                  </span>
                )}
              </div>
              <div className="col-md-6 mb-2">
                <label className="form-label">Last Name</label>
                <span style={{ color: "red" }}>*</span>
                <input
                  type="text"
                  className="form-control"
                  value={lastName}
                  onChange={(event) => {
                    setLastName(event.target.value);
                    ValidateLastName(event.target.value);
                  }}
                />
                {!lastNameValidation.isValid && (
                  <span style={{ color: "red" }}>
                    {lastNameValidation.message}
                  </span>
                )}
              </div>
              <div className="col-md-6 mb-2">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  value={email}
                  onChange={(event) => {
                    setEmail(event.target.value);
                  }}
                  disabled
                />
              </div>
            </form>
          </div>
        </div>
      </Modal>

      {/* <------Update Profile Image Model-------> */}
      <Modal
        height={700}
        className="custom-ant-modal"
        title="Update Profile Image"
        visible={showImageModel}
        onCancel={() => {
          setShowImageModel(false);
        }}
        footer={[
          <Button
            className="submit-button text-white"
            key="submit"
            type="primary"
            onClick={() => {
              if (imgRef.current !== null) {
                setCanvasPreview(
                  imgRef.current,
                  previewCanvasRef.current,
                  convertToPixelCrop(
                    crop,
                    imgRef.current.width,
                    imgRef.current.height
                  )
                );
                setImageDataUrl(
                  previewCanvasRef.current.toDataURL("image/jpeg")
                );
              }
              setShowImageModel(false);
            }}
          >
            UPDATE
          </Button>,
          <Button
            className="btn-submit-secondary"
            key="back"
            onClick={() => {
              setShowImageModel(false);
              if (fileInputRef.current) {
                fileInputRef.current.value = "";
              }
              setImageSrc("");
            }}
          >
            CANCEL
          </Button>,
        ]}
      >
        <div>
          <input
            type="file"
            id="fileInput"
            accept=".jpg, .png, .jpeg, image/jpeg, image/png"
            onChange={handleFileChange}
            ref={fileInputRef}
            className="my-3"
          />
          {imageError && <p style={{ color: "red" }}>{imageError}</p>}
          {imageSrc && (
            <div>
              <ReactCrop
                crop={crop}
                circularCrop
                keepSelection
                aspect={ASPECT_RATIO}
                minWidth={MIN_DIMENSION}
                onChange={(pixelCrop, percentCrop) => setCrop(percentCrop)}
              >
                <img
                  ref={imgRef}
                  src={imageSrc}
                  alt="Upload"
                  style={{ maxHeight: "70vh" }}
                  onLoad={onImageLoad}
                />
              </ReactCrop>
            </div>
          )}
          {crop && (
            <canvas
              className="mt-4"
              ref={previewCanvasRef}
              style={{
                display: "none",
                border: "1px solid black",
                objectFit: "contain",
                width: 150,
                height: 150,
              }}
            ></canvas>
          )}
        </div>
      </Modal>

      <Lodder show={show} />
    </>
  );
};
export default Profile;
